import { CellContext } from '@tanstack/react-table';
import { getTableMeta, UnallocatedCampaignsRow } from '../../helpers';
import { SkeletonizedValue } from '@round/ui-kit';
import styles from './CampaignCell.module.css';
import { Link } from 'react-router-dom';
import { getCampaignLink } from 'Modules/Plans/Campaigns/helpers';
import CampaignImage from 'Modules/Plans/Campaigns/components/CampaignImage/CampaignImage';
import useClientSelect from 'Modules/Plans/Clients/hooks/useClientSelect';
import { TooltipOnOverflow } from '@round/whitelabel-ui';

type Context = CellContext<UnallocatedCampaignsRow, any>;

const CampaignCell = ({ row: { original }, table }: Context) => {
    const { isLoading, getIsBrandLoading, getIsProjectLoading } = getTableMeta(table);
    const { selectedClient, clientDataStatus } = useClientSelect();
    const isSupplementaryDataLoading = Boolean(
        getIsBrandLoading?.(original) || getIsProjectLoading?.(original) || clientDataStatus === 'loading'
    );
    const subLabel = `${original.brand?.name} | ${original.project?.name}`;
    const isEmptyObject = Object.keys(original).length === 0;
    const clientLabel = selectedClient?.name ?? '-';

    return (
        <div className={styles.container}>
            <CampaignImage
                className={styles.image}
                imageUrl={original.project?.image ?? null}
                alt={original.brand?.name ?? 'Brand image'}
                managedBy={original.managed_by ?? null}
                platform={original.platform ?? null}
                isLoading={isSupplementaryDataLoading}
            />

            <div className={styles.labels}>
                <TooltipOnOverflow tooltip={<p className={styles.tooltip}>{original.name}</p>}>
                    <Link className={styles.campaignName} to={getCampaignLink(original)} target="_blank">
                        <SkeletonizedValue isInitialized={!isLoading && !isEmptyObject} width="10rem">
                            {original.name}
                        </SkeletonizedValue>
                    </Link>
                </TooltipOnOverflow>

                <TooltipOnOverflow tooltip={<p className={styles.tooltip}>{subLabel}</p>}>
                    <p className={styles.campaignSublabel}>
                        <SkeletonizedValue
                            isInitialized={!isLoading && !isEmptyObject && !isSupplementaryDataLoading}
                            width="7rem"
                        >
                            {subLabel}
                        </SkeletonizedValue>
                    </p>
                </TooltipOnOverflow>

                <TooltipOnOverflow tooltip={<p className={styles.tooltip}>{clientLabel}</p>}>
                    <p className={styles.campaignSublabel}>
                        <SkeletonizedValue
                            isInitialized={!isLoading && !isEmptyObject && !isSupplementaryDataLoading}
                            width="7rem"
                        >
                            {clientLabel}
                        </SkeletonizedValue>
                    </p>
                </TooltipOnOverflow>
            </div>
        </div>
    );
};

export default CampaignCell;
